<template lang="pug">
    div(style="display:flex; justify-content:center; align-items:center; height:calc(100vh - 280px);")
        div(class="d-flex alternative-main-text pa-4") {{ $t('alternative_text') }}
</template>

<script>
export default {
    name: 'ImpactMetrics'
}
</script>

<style scoped>
div {
    font-size: 24px;
    font-weight: 500;
}

.alternative-main-text {
    width: 460px;
    border-radius: 6px;
    box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.2);
}
</style>
